import { Box, Button, Text } from "@modernatx-internal/component-library";
import React from "react";

import type { PrefectureSearchProps } from "@/content-V2/types";
import { useFinder } from "@/finder/hooks/V2/useFinder";

export const PrefectureSearch: React.FC<PrefectureSearchProps> = (props) => {
  const { buttonText, errorHeader, header, description, prefectureParam } = props;
  const { country, visibleSearchResults } = useFinder();

  const resultSize = visibleSearchResults.length || 0;

  return (
    <Box
      sx={{
        backgroundColor: "white",
        borderRadius: ["initial", null, "radius-2"],
        display: "flex",
        flexDirection: "column",
        gap: "spacing-3",
        px: "spacing-7",
        py: ["spacing-3", null, "spacing-5"],
        alignItems: "flex-start"
      }}
    >
      {prefectureParam ? (
        <Text variant="h5" weight={"medium"}>
          {prefectureParam}
          {header}
          <Text variant="body-1-regular" sx={{ px: "spacing-2" }}>
            ({resultSize})
          </Text>
        </Text>
      ) : (
        <Text variant="h5"> {errorHeader}</Text>
      )}
      {country === "jp" && <Text variant="body-2-regular">{description}</Text>}
      <Button
        size="md"
        variant="outline"
        sx={{ p: ["spacing-3", null, "spacing-5"] }}
        href="/jp/finderform"
      >
        {buttonText}
      </Button>
    </Box>
  );
};
